(() => {
  const section = document.getElementById('friday-with-jess');
  const gallery = section?.querySelector('.jess-gallery');
  if (!gallery) return;
  const controls = [...section.querySelectorAll('[data-jess-direction]')];
  const update = () => controls.forEach(button => {
    button.disabled = Number(button.dataset.jessDirection) < 0
      ? gallery.scrollLeft < 2
      : gallery.scrollLeft + gallery.clientWidth >= gallery.scrollWidth - 2;
  });
  const move = direction => gallery.scrollBy({
    left: direction * (gallery.querySelector('figure').getBoundingClientRect().width + parseFloat(getComputedStyle(gallery).columnGap || '0')),
    behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
  });
  controls.forEach(button => button.addEventListener('click', () => move(Number(button.dataset.jessDirection))));
  gallery.addEventListener('keydown', event => {
    if (event.target !== gallery || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
    event.preventDefault();
    move(event.key === 'ArrowRight' ? 1 : -1);
  });
  gallery.addEventListener('scroll', update, {passive:true});
  window.addEventListener('resize', update, {passive:true});
  update();
})();
